/**
 * @desc 财务
 */

const finOrderList = (r) =>
  require.ensure(
    [],
    () => r(require('../views/finance/FinOrderList.vue')),
    'finOrderList'
  )

const refundList = (r) =>
  require.ensure(
    [],
    () => r(require('../views/finance/RefundList.vue')),
    'refundList'
  )

const paySetting = (r) =>
  require.ensure(
    [],
    () => r(require('../views/finance/PaySetting.vue')),
    'paySetting'
  )

const addPaySetting = (r) =>
  require.ensure(
    [],
    () => r(require('../views/finance/AddPaySetting.vue')),
    'addPaySetting'
  )
const expenseMangement = (r) =>
  require.ensure(
    [],
    () => r(require('../views/finance/ExpenseMangement.vue')),
    'expenseMangement'
  )

const addExpense = (r) =>
  require.ensure(
    [],
    () => r(require('../views/finance/AddExpense.vue')),
    'addExpense'
  )

export default [
  //订单
  {
    name: 'finOrderList',
    path: '/finOrderList',
    component: finOrderList,
    meta: { title: '订单' },
  },
  //退款管理
  {
    name: 'refundList',
    path: '/refundList',
    component: refundList,
    meta: { title: '退款' },
  },

  //支付设置
  {
    name: 'paySetting',
    path: '/paySetting',
    component: paySetting,
    meta: { title: '支付', showfater: true },
    children: [
      {
        name: 'addPaySetting',
        path: '/addPaySetting',
        component: addPaySetting,
        meta: { title: '支付设置', showfater: false },
      },
    ],
  },
  //费用管理
  {
    name: 'expenseMangement',
    path: '/expenseMangement',
    component: expenseMangement,
    meta: { title: '费用管理', showfater: true },
    children: [
      {
        name: 'addExpense',
        path: '/addExpense',
        component: addExpense,
        meta: { title: '费用申请', showfater: false },
      },
    ],
  },
]
